import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import updateLocale from 'dayjs/plugin/updateLocale';

export class DateUtils {
	private static initialized = false;
	private static userTimezone: string = Intl.DateTimeFormat().resolvedOptions().timeZone;
	private static INIT(): void {
		if (this.initialized) return;
		this.initialized = true;
		dayjs.extend(utc);
		dayjs.extend(timezone);
		dayjs.extend(updateLocale);
		dayjs.tz.setDefault(this.userTimezone); // Set the default timezone to the user's timezone
	}

	constructor() {}

	public static formatLocal(date: Date, formatString: string = 'YYYY-MM-DD HH:mm:ss'): string {
		this.INIT();
		return dayjs(date).format(formatString);
	}

	public static formatForServer(date: Date): string {
		this.INIT();
		return dayjs(date).utc().format();
	}

	public static parseFromServer(utcString: string): Date {
		this.INIT();
		return dayjs(utcString).tz(this.userTimezone).toDate();
	}

	public static getTimezoneOffset(): number {
		return new Date().getTimezoneOffset();
	}
}
